/* ============================================================
   WFS — przelatujacy komar (mikroanimacja z wytycznych agencji)
   ------------------------------------------------------------
   - co jakis czas komar przelatuje przez ekran (kazda strona),
     za nim zostaja kropki, ktore powoli znikaja
   - ruch: kreta trasa (krzywa Beziera) + chwiejne zakosy,
     drganie skrzydel i chwilowe "zawisanie", jak u komara
   - lekkosc: jeden element SVG, tylko transform/opacity,
     elementy usuwane po przelocie, start w czasie bezczynnosci
   - wylaczony przy prefers-reduced-motion i w ukrytej karcie
   - test: dopisz ?wfs_komar=1 do adresu (przelot od razu)
   ============================================================ */
(function () {
  'use strict';

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var FIRST_MIN = 5000, FIRST_MAX = 5500;    // pierwszy przelot ok. 5 s po wejsciu
  var NEXT_MIN = 45000, NEXT_MAX = 90000;     // kolejne co 45-90 s
  var MAX_FLIGHTS = 3;                        // najwyzej 3 przeloty na odslone
  var COLOR = '#DAD5C1';                      // Wild Clay

  var SVG =
    '<svg viewBox="20 20 670 570" fill="none" stroke="currentColor" stroke-width="48" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<path d="M392 268C392 200 380 120 352 78C334 52 312 60 298 80C286 100 290 150 300 190C310 240 330 268 360 278C375 282 386 276 392 268"/>' +
    '<path d="M332 300C300 268 250 245 190 243C140 243 100 255 72 270C50 284 50 318 74 336C100 356 150 350 190 332C230 314 255 308 300 310L332 306"/>' +
    '<path d="M430 276C480 255 540 228 600 192C620 180 640 172 652 178"/>' +
    '<path d="M336 302L340 332"/>' +
    '<path d="M318 362C280 375 250 392 228 418C212 438 200 460 194 488"/>' +
    '<path d="M334 346C328 400 322 450 324 495C326 525 332 540 340 552"/>' +
    '<path d="M378 348C392 380 404 410 412 450C420 490 428 515 440 532"/>' +
    '<path d="M388 338C420 340 440 350 455 365C470 385 480 400 498 414C515 430 522 455 528 490"/>' +
    '<circle cx="436" cy="278" r="38" fill="currentColor" stroke="none"/>' +
    '</svg>';

  var flights = 0;
  var flying = false;

  function rand(a, b) { return a + Math.random() * (b - a); }

  function injectStyle() {
    var css =
      '.wfs-mosq{position:fixed;left:0;top:0;z-index:25;pointer-events:none;color:' + COLOR + ';will-change:transform}' +
      '.wfs-mosq svg{display:block;width:100%;height:100%;overflow:visible}' +
      '.wfs-mosq-dot{position:fixed;left:0;top:0;z-index:24;pointer-events:none;border-radius:50%;background:' + COLOR + ';animation:wfs-mosq-fade 1s ease-out forwards}' +
      '@keyframes wfs-mosq-fade{0%{opacity:.85}50%{opacity:.4}100%{opacity:0}}';
    var s = document.createElement('style');
    s.textContent = css;
    document.head.appendChild(s);
  }

  function bezier(p0, p1, p2, p3, t) {
    var u = 1 - t;
    return u * u * u * p0 + 3 * u * u * t * p1 + 3 * u * t * t * p2 + t * t * t * p3;
  }

  function fly() {
    if (flying || document.hidden) return schedule(NEXT_MIN, NEXT_MAX);
    // nie przelatuj nad otwartym drawerem / modalem
    if (document.documentElement.classList.contains('js-drawer-open') ||
        document.body.classList.contains('js-drawer-open')) return schedule(15000, 30000);

    flying = true;
    flights++;

    var vw = window.innerWidth, vh = window.innerHeight;
    var size = vw < 769 ? 30 : 40;
    var ltr = Math.random() < 0.5;
    var x0 = ltr ? -size * 1.5 : vw + size * 1.5;
    var x3 = ltr ? vw + size * 1.5 : -size * 1.5;
    var y0 = rand(0.18, 0.7) * vh, y3 = rand(0.15, 0.75) * vh;
    // dwa losowe punkty kontrolne = kreta, niesymetryczna trasa
    var x1 = x0 + (x3 - x0) * rand(0.2, 0.4), y1 = rand(0.1, 0.85) * vh;
    var x2 = x0 + (x3 - x0) * rand(0.6, 0.8), y2 = rand(0.1, 0.85) * vh;

    var el = document.createElement('div');
    el.className = 'wfs-mosq';
    el.setAttribute('aria-hidden', 'true');
    el.style.width = size + 'px';
    el.style.height = Math.round(size * 0.85) + 'px';
    el.innerHTML = SVG;
    document.body.appendChild(el);

    // predkosc ~ 300-390 px/s (na telefonie odpowiednio wolniej)
    var dist = Math.abs(x3 - x0) * 1.15;
    var baseSpeed = rand(300, 390) * (vw < 769 ? 0.7 : 1);
    var duration = dist / baseSpeed;          // s, przy stalej predkosci
    // losowe fazy chwiejnego lotu
    var ph = [rand(0, 6.28), rand(0, 6.28), rand(0, 6.28), rand(0, 6.28), rand(0, 6.28)];
    var wobA = rand(10, 18), wobB = rand(4, 8);

    var p = 0, time = 0, last = 0, angle = 0;
    // nagle zwroty: co 0.4-1.0 s nowy cel odchylenia od trasy, do ktorego
    // komar szybko "doskakuje" (ostra zmiana kierunku, ale bez drgania)
    var ox = 0, oy = 0, tx = 0, ty = 0, nextJink = rand(0.3, 0.6), brake = 0;
    var px = null, py = null;
    var lastDotX = null, lastDotY = null;
    var dotSize = vw < 769 ? 2 : 3;
    var flip = ltr ? 1 : -1;

    function frame(now) {
      if (!last) last = now;
      // czas rzeczywisty niezaleznie od fps; limit chroni przed skokiem po powrocie do karty
      var dt = Math.min((now - last) / 1000, 0.25);
      last = now;
      time += dt;

      // zmienna predkosc: lekko zwalnia i przyspiesza
      var mul = 0.75 + 0.35 * Math.sin(ph[0] + time * 1.6) * Math.sin(ph[1] + time * 0.85);
      if (mul < 0.35) mul = 0.35;
      // nowy zwrot: losowy skok w gore/dol (czasem tez na chwile w tyl)
      nextJink -= dt;
      if (nextJink <= 0) {
        nextJink = rand(0.4, 1.0);
        ty = rand(-1, 1) * size * 1.6;
        tx = (Math.random() < 0.25 ? -1 : 1) * rand(0.2, 0.9) * size;
        brake = rand(0.08, 0.16);
      }
      // tuz po zwrocie krotkie przyhamowanie wzdluz trasy
      if (brake > 0) { brake -= dt; mul *= 0.35; }
      var k = 1 - Math.exp(-dt * 14);
      ox += (tx - ox) * k;
      oy += (ty - oy) * k;
      p += (dt / duration) * mul * 1.15;

      if (p >= 1) {
        el.remove();
        flying = false;
        if (flights < MAX_FLIGHTS) schedule(NEXT_MIN, NEXT_MAX);
        return;
      }

      var bx = bezier(x0, x1, x2, x3, p), by = bezier(y0, y1, y2, y3, p);
      // trasa + nagle zwroty + lekkie falowanie
      var x = bx + ox * flip + Math.sin(ph[2] + time * 2.3) * wobB * 0.5;
      var y = by + oy + Math.sin(ph[3] + time * 3.1) * wobA * 0.3;

      // przechylenie wg faktycznego kierunku ruchu (max +-35 stopni)
      if (px !== null && dt > 0) {
        var vx = (x - px) * flip, vy = y - py;
        var target = Math.atan2(vy, Math.max(vx, 2)) * 57.3;
        if (target > 35) target = 35;
        if (target < -35) target = -35;
        angle += (target - angle) * (1 - Math.exp(-dt * 12));
      }
      px = x; py = y;

      el.style.transform = 'translate3d(' + (x - size / 2).toFixed(1) + 'px,' + (y - size / 2).toFixed(1) + 'px,0) scaleX(' + flip + ') rotate(' + (angle * flip).toFixed(1) + 'deg)';

      // kropka co ok. 16 px drogi, w miejscu, ktore komar wlasnie minal (krotki ogonek jak w makiecie)
      if (lastDotX === null || Math.abs(x - lastDotX) + Math.abs(y - lastDotY) > 12) {
        lastDotX = x; lastDotY = y;
        var d = document.createElement('span');
        d.className = 'wfs-mosq-dot';
        d.style.width = d.style.height = dotSize + 'px';
        d.style.transform = 'translate3d(' + (x - dotSize / 2 - flip * size * 0.08).toFixed(1) + 'px,' + (y + size * 0.05).toFixed(1) + 'px,0)';
        d.addEventListener('animationend', function () { this.remove(); });
        document.body.appendChild(d);
      }

      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function schedule(min, max) {
    window.setTimeout(function () {
      if ('requestIdleCallback' in window) window.requestIdleCallback(fly, { timeout: 2000 });
      else fly();
    }, rand(min, max));
  }

  function init() {
    injectStyle();
    if (/[?&]wfs_komar=1/.test(window.location.search)) schedule(800, 1200);
    else schedule(FIRST_MIN, FIRST_MAX);
  }

  if (document.readyState === 'complete') init();
  else window.addEventListener('load', init);
})();
